import React, { useRef, useState } from "react";
import OmniFormGroup from "../../../Shared/OmniFormGroup/OmniFormGroup";
import ValidationErrors from "../../../Settings/ValidationErrors";
import DateFormatters from "../../../../constants/DateFormatters";
import { Formik } from "formik";
import * as Yup from "yup";

const { getDate } = DateFormatters;

const validationSchema = (_) => {
  const msg = _.ClientForms.ClientOrder.ValidationMessages;
  return Yup.object({
    company: Yup.string().required(msg.company).max(80, msg.messageMaxLength80),
    name: Yup.string().required(msg.name).max(80, msg.messageMaxLength80),
    email: Yup.string()
      .email(msg.emailFormat)
      .required(msg.email)
      .max(80, msg.messageMaxLength80),
    phone: Yup.string().required(msg.phone).max(40, msg.messageMaxLength40),
    authorisedBy: Yup.string().max(40, msg.messageMaxLength40),
    department: Yup.string().max(40, msg.messageMaxLength40),
    addressLine1: Yup.string().required(msg.addressLine1),
    addressLine2: Yup.string()
      .required(msg.addressLine2)
      .max(40, msg.messageMaxLength40),
    addressLine3: Yup.string().max(40, msg.messageMaxLength40),
    postCode: Yup.string()
      .required(msg.postCode)
      .max(10, msg.messageMaxLength10),
    accountNumber: Yup.string()
      .required(msg.accountNumber)
      .max(40, msg.messageMaxLength40),
    barcode: Yup.string().required(msg.barcode).max(40, msg.messageMaxLength40),
    uniqueId: Yup.string().max(40, msg.messageMaxLength40),
    destroyDate: Yup.string().max(80, msg.messageMaxLength80),
    size: Yup.string(),
    driverInstructions: Yup.string(),
    additionalInformation: Yup.string(),
  });
};

export const Form = ({ _, SystemDetail }) => {
  const url = `${window.document.location.origin}/client-forms/client-order-completed`;

  const [returnUrl, setreturnUrl] = useState(url);
  const fields = _.ClientForms.ClientOrder.Fields;

  const formEl = useRef(null);

  const objectToQuerystring = (obj) => {
    return Object.keys(obj).reduce(function (str, key, i) {
      var delimiter, val;
      delimiter = i === 0 ? "?" : "&";
      key = encodeURIComponent(key);
      val = encodeURIComponent(obj[key]);
      return [str, delimiter, key, "=", val].join("");
    }, "");
  };

  return (
    <Formik
      initialValues={{
        authorisedBy: "",
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        postCode: "",
        accountNumber: "",
        barcode: "",
        uniqueId: "",
        destroyDate: "",
        size: "",
        driverInstructions: "",
        additionalInformation: "",
        ...SystemDetail,
      }}
      onSubmit={(values) => {
        const queryString = objectToQuerystring(values);
        setreturnUrl(`${url}${queryString}`);
        formEl.current.submit();
      }}
      validationSchema={validationSchema(_)}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        setFieldTouched,
        isValid,
      }) => (
        <>
          <form
            ref={formEl}
            action="https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8"
            method="POST"
            target="_top"
          >
            <input type="hidden" name="orgid" value="00D70000000Mc9e" />
            <input type="hidden" name="retURL" value={returnUrl} />
            <input type="hidden" name="00N4u000003xKkh" value="Client Order" />
            <input
              type="hidden"
              name="debugEmail"
              value="awhittaker@oasisgroup.com"
            />
            <div className="d-flex flex-wrap ml-3 client-order">
              <div className="mr-4 my-1">
                <input type="hidden" name="company" value={values.company} />
                <OmniFormGroup
                  Id="company"
                  Name="company"
                  Type="text"
                  Placeholder={fields.company}
                  LabelName={
                    <>
                      {fields.company} <span className="required"></span>
                    </>
                  }
                  Value={values.company}
                  onChange={handleChange}
                  maxLength={80}
                  Disabled
                ></OmniFormGroup>
                <ValidationErrors
                  touched={touched.company}
                  message={errors.company}
                ></ValidationErrors>
              </div>
              <div className="mr-4 my-1">
                <input type="hidden" name="name" value={values.name} />
                <OmniFormGroup
                  Id="name"
                  Name="name"
                  Type="text"
                  LabelName={
                    <>
                      {fields.name} <span className="required"></span>
                    </>
                  }
                  Placeholder={fields.name}
                  Value={values.name}
                  onChange={handleChange}
                  maxLength={80}
                  Disabled
                ></OmniFormGroup>
                <ValidationErrors
                  touched={touched.name}
                  message={errors.name}
                ></ValidationErrors>
              </div>
              <div className="mr-4 my-1">
                <input type="hidden" name="email" value={values.email} />
                <OmniFormGroup
                  Id="email"
                  Name="email"
                  Type="email"
                  Placeholder={fields.email}
                  LabelName={
                    <>
                      {fields.email} <span className="required"></span>
                    </>
                  }
                  Value={values.email}
                  onChange={handleChange}
                  maxLength={80}
                  Disabled
                ></OmniFormGroup>
                <ValidationErrors
                  touched={touched.email}
                  message={errors.email}
                ></ValidationErrors>
              </div>
              <div className="mr-4 my-1">
                <input type="hidden" name="phone" value={values.phone} />
                <OmniFormGroup
                  Id="phone"
                  Name="phone"
                  Type="text"
                  Placeholder="07945 349 545"
                  LabelName={
                    <>
                      {fields.phone} <span className="required"></span>
                    </>
                  }
                  Value={values.phone}
                  onChange={handleChange}
                  maxLength={40}
                  Disabled
                ></OmniFormGroup>
                <ValidationErrors
                  touched={touched.phone}
                  message={errors.phone}
                ></ValidationErrors>
              </div>
              <div className="mr-4 my-1">
                <OmniFormGroup
                  Id="00N4u000003xJh8"
                  Name="00N4u000003xJh8"
                  Type="text"
                  Placeholder={fields.authorisedBy}
                  LabelName={fields.authorisedBy}
                  Value={values.authorisedBy}
                  onChange={(e) => {
                    setFieldValue("authorisedBy", e.target.value);
                  }}
                  maxLength={40}
                ></OmniFormGroup>
                <ValidationErrors
                  touched={touched.authorisedBy}
                  message={errors.authorisedBy}
                ></ValidationErrors>
              </div>
              <div className="mr-4 my-1">
                <OmniFormGroup
                  Id="00N4u000003xJ4C"
                  Name="00N4u000003xJ4C"
                  Type="text"
                  LabelName={fields.department}
                  Placeholder={fields.department}
                  Value={values.department}
                  onChange={(e) => {
                    setFieldValue("department", e.target.value);
                  }}
                  maxLength={40}
                ></OmniFormGroup>
                <ValidationErrors
                  touched={touched.department}
                  message={errors.department}
                ></ValidationErrors>
              </div>
              <div className="mr-4 my-1">
                <OmniFormGroup
                  Id="00N4u000003xIxV"
                  Name="00N4u000003xIxV"
                  Type="textarea"
                  LabelName={
                    <>
                      {fields.addressLine1} <span className="required"></span>
                    </>
                  }
                  Placeholder={fields.addressLine1}
                  Value={values.addressLine1}
                  onChange={(e) => {
                    setFieldValue("addressLine1", e.target.value);
                  }}
                ></OmniFormGroup>
                <ValidationErrors
                  touched={touched.addressLine1}
                  message={errors.addressLine1}
                ></ValidationErrors>
              </div>
              <div className="mr-4 my-1">
                <OmniFormGroup
                  Id="00N4u000003xIxa"
                  Name="00N4u000003xIxa"
                  Type="text"
                  LabelName={
                    <>
                      {fields.addressLine2} <span className="required"></span>
                    </>
                  }
                  Placeholder={fields.addressLine2}
                  Value={values.addressLine2}
                  onChange={(e) => {
                    setFieldValue("addressLine2", e.target.value);
                  }}
                  maxLength={40}
                ></OmniFormGroup>
                <ValidationErrors
                  touched={touched.addressLine2}
                  message={errors.addressLine2}
                ></ValidationErrors>
              </div>
              <div className="mr-4 my-1">
                <OmniFormGroup
                  Id="00N4u000003xIxf"
                  Name="00N4u000003xIxf"
                  Type="text"
                  LabelName={fields.addressLine3}
                  Placeholder={fields.addressLine3}
                  Value={values.addressLine3}
                  onChange={(e) => {
                    setFieldValue("addressLine3", e.target.value);
                  }}
                  maxLength={40}
                ></OmniFormGroup>
                <ValidationErrors
                  touched={touched.addressLine3}
                  message={errors.addressLine3}
                ></ValidationErrors>
              </div>
              <div className="mr-4 my-1">
                <OmniFormGroup
                  Id="00N4u000003xIxk"
                  Name="00N4u000003xIxk"
                  Type="text"
                  LabelName={
                    <>
                      {fields.postCode} <span className="required"></span>
                    </>
                  }
                  Placeholder={fields.postCode}
                  Value={values.postCode}
                  onChange={(e) => {
                    setFieldValue("postCode", e.target.value);
                  }}
                  maxLength={10}
                ></OmniFormGroup>
                <ValidationErrors
                  touched={touched.postCode}
                  message={errors.postCode}
                ></ValidationErrors>
              </div>
              <div className="mr-4 my-1">
                <OmniFormGroup
                  Id="00N4u000003xJ4H"
                  Name="00N4u000003xJ4H"
                  Type="text"
                  LabelName={
                    <>
                      {fields.accountNumber} <span className="required"></span>
                    </>
                  }
                  Placeholder={fields.accountNumber}
                  Value={values.accountNumber}
                  onChange={(e) => {
                    setFieldValue("accountNumber", e.target.value);
                  }}
                  maxLength={40}
                ></OmniFormGroup>
                <ValidationErrors
                  touched={touched.accountNumber}
                  message={errors.accountNumber}
                ></ValidationErrors>
              </div>
              <div className="mr-4 my-1">
                <OmniFormGroup
                  Id="00N4u000003xJ4M"
                  Name="00N4u000003xJ4M"
                  Type="text"
                  LabelName={
                    <>
                      {fields.barcode} <span className="required"></span>
                    </>
                  }
                  Placeholder={fields.barcode}
                  Value={values.barcode}
                  onChange={(e) => {
                    setFieldValue("barcode", e.target.value);
                  }}
                  maxLength={40}
                ></OmniFormGroup>
                <ValidationErrors
                  touched={touched.barcode}
                  message={errors.barcode}
                ></ValidationErrors>
              </div>
              <div className="mr-4 my-1">
                <OmniFormGroup
                  Id="00N4u000003xJ4R"
                  Name="00N4u000003xJ4R"
                  Type="text"
                  LabelName={fields.uniqueId}
                  Placeholder={fields.uniqueId}
                  Value={values.uniqueId}
                  onChange={(e) => {
                    setFieldValue("uniqueId", e.target.value);
                  }}
                  maxLength={40}
                ></OmniFormGroup>
                <ValidationErrors
                  touched={touched.uniqueId}
                  message={errors.uniqueId}
                ></ValidationErrors>
              </div>
              <div className="mr-4 my-1">
                <input
                  type="hidden"
                  name="00N4u000003xJhN"
                  value={values.destroyDate}
                />
                <OmniFormGroup
                  Id="destroyDate"
                  Name="destroyDate"
                  Type="date"
                  LabelName={fields.destroyDate}
                  Placeholder={fields.destroyDate}
                  Value={values.destroyDate}
                  onChange={(e) => {
                    setFieldValue("destroyDate", getDate(e));
                  }}
                ></OmniFormGroup>
              </div>
              <div className="mr-4 my-1">
                <OmniFormGroup
                  Id="00N4u000003xJ4W"
                  Name="00N4u000003xJ4W"
                  Type="text"
                  LabelName={fields.size}
                  Placeholder={fields.size}
                  Value={values.size}
                  onChange={(e) => {
                    setFieldValue("size", e.target.value);
                  }}
                ></OmniFormGroup>
                <ValidationErrors
                  touched={touched.size}
                  message={errors.size}
                ></ValidationErrors>
              </div>
              <div className="mr-4 my-1">
                <OmniFormGroup
                  Id="00N4u000003xJhD"
                  Name="00N4u000003xJhD"
                  Type="textarea"
                  LabelName={fields.driverInstructions}
                  Placeholder={fields.driverInstructions}
                  Value={values.driverInstructions}
                  onChange={(e) => {
                    setFieldValue("driverInstructions", e.target.value);
                  }}
                ></OmniFormGroup>
                <ValidationErrors
                  touched={touched.driverInstructions}
                  message={errors.driverInstructions}
                ></ValidationErrors>
              </div>
              <div className="mr-4 my-1">
                <OmniFormGroup
                  Id="00N4u000003xJhI"
                  Name="00N4u000003xJhI"
                  Type="textarea"
                  LabelName={fields.additionalInformation}
                  Placeholder={fields.additionalInformation}
                  Value={values.additionalInformation}
                  onChange={(e) => {
                    setFieldValue("additionalInformation", e.target.value);
                  }}
                ></OmniFormGroup>
                <ValidationErrors
                  touched={touched.additionalInformation}
                  message={errors.additionalInformation}
                ></ValidationErrors>
              </div>
            </div>
            <div className="d-flex mt-3 ml-3">
              <button
                className="styled-button"
                type="submit"
                disabled={isSubmitting || !isValid}
                onClick={handleSubmit}
              >
                {_.ClientForms.ClientOrder.SubmitForm}
              </button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
};
